import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useCallback, Fragment } from 'react';
import { FodalCardBase } from './fodal-card-base.esm.js';
import { Expand } from './expand.esm.js';
import { Card, Flex, Text, Button, Divider } from '@costar/theme-ui';

var _excluded = ["title", "navigationProps", "expandProps", "messages"];
var Fodal = function Fodal(_ref) {
  var _props$modalProps, _messages$close;
  var title = _ref.title,
    navigationProps = _ref.navigationProps,
    expandProps = _ref.expandProps,
    messages = _ref.messages,
    props = _objectWithoutProperties(_ref, _excluded);
  var onClose = (_props$modalProps = props.modalProps) === null || _props$modalProps === void 0 ? void 0 : _props$modalProps.onClose;
  var onCloseClick = useCallback(function () {
    return onClose && onClose({}, 'backdropClick');
  }, [onClose]);
  return /*#__PURE__*/React.createElement(FodalCardBase, _extends({}, props, {
    cardHeader: /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Card.Title, null, title), /*#__PURE__*/React.createElement(Flex, {
      alignSelf: "center",
      justifyContent: "flex-end",
      alignItems: "center",
      lineHeight: "md"
    }, navigationProps && /*#__PURE__*/React.createElement(Fragment, null, navigationProps.title && /*#__PURE__*/React.createElement(Text, {
      variant: "fodal.navigation.title"
    }, navigationProps.title), navigationProps.selectPrev && /*#__PURE__*/React.createElement(Button, {
      variant: "fodal.navigation.button",
      icon: "chevronLeft",
      iconSize: "sm",
      p: "0 10px 0 5px",
      m: "0px",
      onClick: navigationProps.selectPrev
    }), navigationProps.selectPrev && navigationProps.selectNext && /*#__PURE__*/React.createElement(Divider, {
      orientation: "vertical",
      backgroundColor: "black",
      opacity: 0.8,
      width: "1px"
    }), navigationProps.selectNext && /*#__PURE__*/React.createElement(Button, {
      variant: "fodal.navigation.button",
      icon: "chevronRight",
      iconSize: "sm",
      p: "0 5px 0 10px",
      m: "0px",
      onClick: navigationProps.selectNext
    })), expandProps && /*#__PURE__*/React.createElement(Expand, _extends({
      variant: "fodal.button",
      icon: "expand",
      iconSize: "sm",
      p: "0"
    }, expandProps)), /*#__PURE__*/React.createElement(Button, {
      variant: "fodal.button",
      icon: "close",
      iconSize: "xs",
      p: "0",
      "aria-label": (_messages$close = messages === null || messages === void 0 ? void 0 : messages.close) !== null && _messages$close !== void 0 ? _messages$close : 'close',
      onClick: onCloseClick
    })))
  }));
};

export { Fodal };
//# sourceMappingURL=fodal.esm.js.map
